import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

// Add auth header
api.interceptors.request.use(config => {
  const token = localStorage.getItem('li-token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public
export const getCategories = () => api.get('/categories');
export const getAllCategories = () => api.get('/categories/all');
export const getMenu = () => api.get('/menu');
export const getMenuByCategory = (catId) => api.get(`/menu/category/${catId}`);
export const getPopularItems = () => api.get('/menu/popular');
export const getMenuItem = (id) => api.get(`/menu/${id}`);
export const getReviews = () => api.get('/reviews');
export const getSettings = () => api.get('/settings');
export const createReservation = (data) => api.post('/reservations', data);
export const createOrder = (data) => api.post('/orders', data);
export const createContact = (data) => api.post('/contact', data);

// Auth
export const login = (data) => api.post('/auth/login', data);
export const getMe = () => api.get('/auth/me');

// Admin - Menu
export const getAdminStats = () => api.get('/admin/stats');
export const getAdminMenu = () => api.get('/admin/menu');
export const createMenuItem = (data) => api.post('/admin/menu', data);
export const updateMenuItem = (id, data) => api.put(`/admin/menu/${id}`, data);
export const deleteMenuItem = (id) => api.delete(`/admin/menu/${id}`);

// Admin - Orders
export const getAdminOrders = () => api.get('/admin/orders');
export const updateOrderStatus = (id, status) => api.put(`/admin/orders/${id}/status`, { status });
export const updateOrderNote = (id, staff_note) => api.put(`/admin/orders/${id}/note`, { staff_note });
export const sendOrderTime = (id, minutes) => api.put(`/admin/orders/${id}/send-time`, { minutes });
export const markOrderPaidCollected = (id) => api.put(`/admin/orders/${id}/paid-collected`);
export const deleteOrder = (id) => api.delete(`/admin/orders/${id}`);

// Admin - Reservations
export const getAdminReservations = () => api.get('/admin/reservations');
export const updateReservationStatus = (id, status) => api.put(`/admin/reservations/${id}/status`, { status });
export const updateReservationNote = (id, staff_note) => api.put(`/admin/reservations/${id}/note`, { staff_note });
export const deleteReservation = (id) => api.delete(`/admin/reservations/${id}`);

// Admin - Tables
export const getAdminTables = () => api.get('/admin/tables');
export const updateTableStatus = (tn, status) => api.put(`/admin/tables/${tn}/status`, { status });
export const getTableBill = (tn) => api.get(`/admin/tables/${tn}/bill`);
export const getAdminTableOrders = () => api.get('/admin/table-orders');
export const updateTableOrderStatus = (id, status) => api.put(`/admin/table-orders/${id}/status`, { status });
export const payTableOrderFull = (id) => api.put(`/admin/table-orders/${id}/pay-full`);
export const payTableOrderItems = (id, item_indices) => api.put(`/admin/table-orders/${id}/pay-items`, { item_indices });

// Admin - Contacts
export const getAdminContacts = () => api.get('/admin/contacts');
export const updateContactStatus = (id, status) => api.put(`/admin/contacts/${id}/status`, { status });
export const updateContactNote = (id, staff_note) => api.put(`/admin/contacts/${id}/note`, { staff_note });
export const deleteContact = (id) => api.delete(`/admin/contacts/${id}`);

// Admin - Reviews
export const getAdminReviews = () => api.get('/admin/reviews');
export const createReview = (data) => api.post('/admin/reviews', data);
export const updateReview = (id, data) => api.put(`/admin/reviews/${id}`, data);
export const deleteReview = (id) => api.delete(`/admin/reviews/${id}`);
export const toggleReview = (id) => api.put(`/admin/reviews/${id}/toggle`);

// Admin - Settings
export const updateSettings = (data) => api.put('/admin/settings', data);

// Admin - Categories
export const createCategory = (data) => api.post('/admin/categories', data);
export const updateCategory = (id, data) => api.put(`/admin/categories/${id}`, data);
export const deleteCategory = (id) => api.delete(`/admin/categories/${id}`);

// Admin - Trash / Papierkorb
export const getTrash = () => api.get('/admin/trash');
export const restoreFromTrash = (type, id) => api.put(`/admin/trash/${type}/${id}/restore`);
export const permanentDeleteFromTrash = (type, id) => api.delete(`/admin/trash/${type}/${id}/permanent`);
export const emptyTrash = () => api.delete('/admin/trash/empty');

// Admin - Email to customer
export const sendAdminEmail = (data) => api.post('/admin/email/send', data);

// Admin - Kassenbuch
export const getKassenbuch = (year, month) => api.get('/admin/kassenbuch', { params: { year, month } });
export const getKassenbuchSummary = (year, month) => api.get('/admin/kassenbuch/summary', { params: { year, month } });
export const createKassenbuchEntry = (data) => api.post('/admin/kassenbuch', data);
export const deleteKassenbuchEntry = (id) => api.delete(`/admin/kassenbuch/${id}`);
export const sendKassenbuchReport = (year, month) => api.post('/admin/kassenbuch/send-report', null, { params: { year, month } });
export const downloadKassenbuchPdf = (year, month) => api.get('/admin/kassenbuch/download', { params: { year, month }, responseType: 'blob' });
export const getKassenbuchReports = () => api.get('/admin/kassenbuch/reports');

// Seed
export const seedData = () => api.post('/seed');

export default api;
